import { render, staticRenderFns } from "./SelectPOS.vue?vue&type=template&id=a4df29bc&"
import script from "./SelectPOS.vue?vue&type=script&lang=js&"
export * from "./SelectPOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports